export type CalendarEventType =
  | 'meeting'
  | 'task'
  | 'milestone'
  | 'schedule_task'
  | 'daily_log'
  | 'rfi'
  | 'todo';

export interface GlobalCalendarEvent {
  id: string;
  type: CalendarEventType;
  title: string;
  startDate: string; // ISO 8601
  endDate: string; // ISO 8601
  allDay: boolean;
  projectId: string;
  projectName: string;
  status: string;
  priority?: string;
  url: string;
  meta?: Record<string, unknown>;
}

export interface CalendarEventsParams {
  dateFrom: string;
  dateTo: string;
  projectIds?: string[];
  eventTypes?: CalendarEventType[];
}

export interface CalendarEventsResponse {
  events: GlobalCalendarEvent[];
  total: number;
}

export type CalendarView = 'month' | 'week' | 'day';

export const CALENDAR_EVENT_TYPES: CalendarEventType[] = [
  'meeting',
  'task',
  'milestone',
  'schedule_task',
  'daily_log',
  'rfi',
  'todo',
];

export const EVENT_TYPE_LABELS: Record<CalendarEventType, string> = {
  meeting: 'Meetings',
  task: 'Tasks',
  milestone: 'Milestones',
  schedule_task: 'Schedule',
  daily_log: 'Daily Logs',
  rfi: 'RFIs',
  todo: 'Todos',
};

export const EVENT_TYPE_COLORS: Record<
  CalendarEventType,
  { bg: string; text: string; dot: string; border: string }
> = {
  meeting: {
    bg: 'bg-red-50',
    text: 'text-red-800',
    dot: 'bg-red-500',
    border: 'border-red-200',
  },
  task: {
    bg: 'bg-blue-50',
    text: 'text-blue-800',
    dot: 'bg-blue-500',
    border: 'border-blue-200',
  },
  milestone: {
    bg: 'bg-purple-50',
    text: 'text-purple-800',
    dot: 'bg-purple-500',
    border: 'border-purple-200',
  },
  schedule_task: {
    bg: 'bg-green-50',
    text: 'text-green-800',
    dot: 'bg-green-500',
    border: 'border-green-200',
  },
  daily_log: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-800',
    dot: 'bg-yellow-500',
    border: 'border-yellow-200',
  },
  rfi: {
    bg: 'bg-orange-50',
    text: 'text-orange-800',
    dot: 'bg-orange-500',
    border: 'border-orange-200',
  },
  todo: {
    bg: 'bg-gray-50',
    text: 'text-gray-800',
    dot: 'bg-gray-500',
    border: 'border-gray-200',
  },
};
